
import cloudKitchen from "~/assets/images/cloud-kitchen.png";
export default {
  data() {
    return {
      cloudKitchen
    };
  }
};
